import { render } from "./CPI.vue?vue&type=template&id=107b1bef&ts=true"
import script from "./CPI.ts?vue&type=script&lang=ts&external"
export * from "./CPI.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__